import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsDigitalSignatureTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader tabName={t('pageIntegrations.tabNames.digital-signatures')} />
      <IntegrationsTable category={IntegrationCategory.DIGITAL_SIGNATURES} />
    </section>
  );
};

export default IntegrationsDigitalSignatureTab;
